import {ServerError} from "@dropDesk/domain/entities/exceptions/exceptions";
import {inject, injectable} from "inversify";
import {PanelAdmRepository} from "@dropDesk/domain/repositories/panel_adm/panel_adm.repository";
import {PanelAdmRemoteDataSource} from "@dropDesk/data/data_source/panel_adm/panel_adm_remote.datasource";
import {CompanyEntity} from "@dropDesk/domain/entities/company/company.entity";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {ChatIntegrationConnectionEntity} from "@dropDesk/domain/entities/chat/chat_integration_connection.entity";
import {PaymentStatus} from "@dropDesk/domain/entities/payment/payment.enum";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";

@injectable()
export class PanelAdmRepositoryImpl implements PanelAdmRepository {
    private _dataSource: PanelAdmRemoteDataSource;

    constructor(@inject(PanelAdmRemoteDataSource) dataSource: PanelAdmRemoteDataSource) {
        this._dataSource = dataSource;
    }

    public getCompanyBySearch(search: string): Promise<{ company: CompanyEntity, user: UserEntity }> {
        try {
            return this._dataSource.getCompanyBySearch(search);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public removeCompanyCache(idCompany: string): Promise<void> {
        try {
            return this._dataSource.removeCompanyCache(idCompany);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public allowSubscriptionUpgrade(idCompany: string, idSubscription: string): Promise<void> {
        try {
            return this._dataSource.allowSubscriptionUpgrade(idCompany, idSubscription);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public chatConnectionState(idCompany: string): Promise<ChatIntegrationConnectionEntity> {
        try {
            return this._dataSource.chatConnectionState(idCompany);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public listPayments(page: number, limit: number, idCompany: string, status?: PaymentStatus): Promise<ListPaginationEntity<PaymentEntity>> {
        try {
            return this._dataSource.listPayments(page, limit, idCompany, status);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public refund(idExternal: string, id: string): Promise<void> {
        try {
            return this._dataSource.refund(idExternal, id);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public externallyPay(idExternal: string, id: string): Promise<void> {
        try {
            return this._dataSource.externallyPay(idExternal, id);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }
}
